// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__1yBxx","buttons":"PendingPaymentAlert_buttons__1SGlH"};